import React from 'react';

import {WidthItem} from 'src/components/width-item';

import {AutosuggestItem} from '@pb/kit-component-autosuggest-v2';
import {AvatarWrapped, Size} from '@pb/kit-component-avatar';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group} from '@pb/kit-component-group';
import {Icons} from '@pb/kit-component-icon';
import Loading from '@pb/kit-component-loading';


import type {AccountManagerSearchResult} from 'src/openapi/admin/models/AccountManagerSearchResult';
import type {ServerResponse} from 'src/typedef';

type Props = {
    id: string,
    busy: boolean,
    response: ServerResponse<Array<AccountManagerSearchResult>> | null,
};

export const AccountTeamMemberSuggestResult = ({busy, response, id}: Props) => {
    if (busy) {
        return (
            <div id={id} className="pd-s">
                <Group><Loading type="ICON"/> Loading</Group>
            </div>
        );
    }

    if (response?.data?.length) {
        return (
            <div id={id}>
                {response.data.map(member => (
                    <AutosuggestItem
                        key={member.id}
                        value={member}
                        caption={(
                            <Group alignItems="center">
                                <AvatarWrapped
                                    src={member.avatar}
                                    alt={member.id.toString()}
                                    placeholder={Icons.USER}
                                    size={Size.SMALL}
                                    name={member.fullName}
                                />
                                <WidthItem width={100}>
                                    {member.fullName ? (
                                        <EllipsisTextHint title={member.fullName}>
                                            {member.fullName}
                                        </EllipsisTextHint>
                                    ) : null}
                                </WidthItem>
                                <WidthItem width={220}>
                                    {member.email ? (
                                        <EllipsisTextHint title={member.email} mix="disabled">
                                            {member.email}
                                        </EllipsisTextHint>
                                    ) : null}
                                </WidthItem>
                            </Group>
                        )}
                    />
                ))}
            </div>
        );
    }

    if (response?.data && !response.data.length) {
        return (
            <div id={id} className="pd-s">
                No accounts found
            </div>
        );
    }

    if (response?.error) {
        return (
            <div id={id} className="pd-s">
                {response.error.message}
            </div>
        );
    }

    return null;
};
